module.exports = "/virtual-football-league/img/amblems/left/logos/Southampton.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/logos/Southampton.png
// module id = 2125
// module chunks = 4